<div class="modal-header">
    <div class="title">
        <h2 class="modal-title">Les états de commande</h2>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column" style="margin: 1rem;">
    <h6>Dans la liste répertoriant les commandes, vous pouvez observer l’information concernant leur état actuel,
        pouvant être les suivants :</h6>
    <h6 style="margin-top: 1rem; text-align: justify;">
        <li>
            <span class="title-hint">A payer</span> : Le paiement de la commande n'a pas encore été effectué. Passé un
            certain délai la commande sera considérée comme annulé sans possibilité de modifications.
        </li>
        <li>
            <span class="title-hint">En attente</span> : La commande est en cours de traitement. Elle peut soit être en
            attente de réception du paiement, soit en cours d'acheminement.
        </li>
        <li>
            <span class="title-hint">En préparation</span> : La commande a été validée par le fournisseur et l'adhérent.
            Elle est actuellement en cours de fabrication. Le client ne peut plus modifier sa commande.
        </li>
        <li>
            <span class="title-hint">Expédié</span> : La commande est sorti d'usine.
        </li>
        <li>
            <span class="title-hint">Livré</span> : La livraison de la commande a été validée. La commande ne peut plus
            être modifiée.
        </li>
        <li>
            <span class="title-hint">Annulé</span> : La commande a été refusée soit par le fournisseur soit par la
            boutique en cas de non réception ou de refus de paiement. La commande ne peut plus être modifiée.
        </li>
        <li>
            <span class="title-hint">Blocage usine</span> : Le fournisseur a rencontré un problème lors de la
            fabrication du produit. Le statut de la commande est bloqué à en attente.
        </li>
        <li>
            <span class="title-hint">Blocage métrage</span> : Le fournisseur ou l'adhérent a rencontré un problème lié
            aux renseignements des dimensions du produit. Le statut de la commande est bloqué à en attente.
        </li>
        <li>
            <span class="title-hint">Annulé la commande (web to store)</span> : La commande a été annulée par l'adhérent
            ou le fournisseur, la prise de commande se fera au magasin et non sur le site web. La commande ne peut plus
            être modifiée.
        </li>
    </h6>
</div>